import { useTranslation } from 'react-i18next';

/**
 * i18next 25's type definitions require TypeScript 5; this package is on 4.9,
 * so `t` resolves to a zero-argument function and every call fails to compile.
 * The rest of the app works around it with an inline
 * `useTranslation() as { t: (key: string) => string }` cast at each call site —
 * this is the same cast, shared across the shell's eight components.
 */
export const useShellTranslation = (): { t: (key: string, options?: any) => string } =>
  useTranslation() as { t: (key: string, options?: any) => string };
